module.exports = {
  "id": "hazard",
  "color": "red",
  "title": "hazard",
  "icon": "flame",
  "category": "destroy",
  "searchTags": ["die", "danger", "spikes", "lava", "skull"],

  "exposedVariables": [
  ],
  "info": [
    {
      "text": "Make a piece into a hazard that destroys other pieces it touches",
      "image": "provision/glitches/hazard/hazard.gif"
    }
  ],
  "codeImage": "provision/glitches/acclerate/hazard.png",
  "code": null,
  "zip": null,
  "sb3": null,
  "image": "provision/parts/hazard/hazard.svg"
};